/* global $ */

function onWindowScroll() {
    if ($(window).scrollTop() > 100) {
        $('.logo a').trigger('mouseenter');
        $('body').addClass('open');
    } else {
        $('body').removeClass('open');
        $('.logo a').trigger('mouseover');
        $('.sub_menu a').removeClass('active');
    }
}

export default onWindowScroll;



// WEBPACK FOOTER //
// ./src/modules/plugins/onWindowScroll.js